@if (forceContinuedStayRequest) {
  <button
    severity="secondary"
    label="Continued Stay Request"
    pButton
    type="button"
    [disabled]="isDisabled"
    [loading]="isLoadingContinuedStay"
    (click)="checkContinuedStayEligibility(true)"
  ></button>
} @else {
  <button
    severity="secondary"
    icon="pi pi-paperclip"
    label="Attach file"
    pButton
    type="button"
    [disabled]="isDisabled"
    [loading]="isLoadingContinuedStay"
    (click)="onClick()"
  ></button>
}
<div class="upload-btn-wrapper">
  <input
    #inputFile
    name="myfile"
    type="file"
    [accept]="accept"
    [disabled]="isDisabled"
    [multiple]="multiple"
    (change)="onFileSelect($event)"
    />
  </div>
